(function () {
  function initCoachPage(root) {
    if (!root || root.dataset.skcReady === 'true') return;
    root.dataset.skcReady = 'true';

    root.querySelectorAll('[data-skc-tabs]').forEach(function (tabs) {
      var buttons = Array.from(tabs.querySelectorAll('[role="tab"]'));
      var panels = Array.from(tabs.querySelectorAll('[role="tabpanel"]'));

      function activateTab(button) {
        var panelId = button.getAttribute('aria-controls');

        buttons.forEach(function (item) {
          var selected = item === button;
          item.setAttribute('aria-selected', selected ? 'true' : 'false');
          item.tabIndex = selected ? 0 : -1;
        });

        panels.forEach(function (panel) {
          var active = panel.id === panelId;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
      }

      buttons.forEach(function (button, index) {
        button.addEventListener('click', function () {
          activateTab(button);
        });

        button.addEventListener('keydown', function (event) {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          event.preventDefault();
          var direction = event.key === 'ArrowRight' ? 1 : -1;
          var nextIndex = (index + direction + buttons.length) % buttons.length;
          buttons[nextIndex].focus();
          activateTab(buttons[nextIndex]);
        });
      });
    });

    var calculator = root.querySelector('[data-skc-calculator]');
    if (calculator) {
      var squadInput = calculator.querySelector('[data-skc-squad]');
      var groupInput = calculator.querySelector('[data-skc-group]');
      var resultNumber = calculator.querySelector('[data-skc-result-number]');
      var resultCopy = calculator.querySelector('[data-skc-result-copy]');

      function updateCalculator() {
        var squad = Math.max(2, parseInt(squadInput.value, 10) || 2);
        var groupSize = Math.max(2, parseInt(groupInput.value, 10) || 4);
        var stations = Math.max(1, Math.ceil(squad / groupSize));
        var recommendation = stations === 1
          ? '1 training station'
          : stations + ' training stations';
        var copy = stations >= 3
          ? 'A multi-set club quote will usually be the best fit for this group.'
          : 'Start with one system per active group to minimize lines and waiting.';

        resultNumber.textContent = recommendation;
        resultCopy.textContent = copy;
      }

      squadInput.addEventListener('input', updateCalculator);
      groupInput.addEventListener('change', updateCalculator);
      updateCalculator();
    }

    var toast = root.querySelector('[data-skc-toast]');
    var toastTimer;

    function showToast(message, isError) {
      if (!toast) return;
      toast.textContent = message;
      toast.style.background = isError ? '#8f2626' : '';
      toast.classList.add('is-visible');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () {
        toast.classList.remove('is-visible');
      }, 2600);
    }

    root.querySelectorAll('[data-skc-add]').forEach(function (button) {
      button.addEventListener('click', function () {
        var variantId = parseInt(button.dataset.variantId, 10);
        var originalLabel = button.dataset.label || button.textContent;

        if (!variantId || button.disabled) return;

        button.disabled = true;
        button.textContent = 'Adding…';

        var routeRoot = window.Shopify && window.Shopify.routes
          ? window.Shopify.routes.root
          : '/';

        fetch(routeRoot + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }]
          })
        })
          .then(function (response) {
            return response.json().then(function (data) {
              if (!response.ok) throw data;
              return data;
            });
          })
          .then(function () {
            button.textContent = 'Added ✓';
            showToast('Added to cart. Your setup is one step closer.', false);

            document.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true
            }));

            return fetch(routeRoot + 'cart.js');
          })
          .then(function (response) {
            if (!response) return null;
            return response.json();
          })
          .then(function (cart) {
            if (!cart) return;
            document.querySelectorAll(
              '.cart-count, [data-cart-count], .cart-item-count, #cart-count, .js-cart-count'
            ).forEach(function (element) {
              element.textContent = cart.item_count;
            });
          })
          .catch(function (error) {
            var message = error && (error.description || error.message)
              ? error.description || error.message
              : 'This item could not be added. Please try again.';
            button.textContent = 'Try again';
            showToast(message, true);
          })
          .finally(function () {
            setTimeout(function () {
              button.disabled = false;
              button.textContent = originalLabel;
            }, 1800);
          });
      });
    });

    root.querySelectorAll('a[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var targetId = link.getAttribute('href');
        if (!targetId || targetId === '#') return;
        var target = root.querySelector(targetId) || document.querySelector(targetId);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-skc-root]').forEach(initCoachPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-skc-root]');
    if (root) initCoachPage(root);
  });
})();
